import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import '../../scss/BackButton.scss';

export default class BackButton extends Component {
  render() {
    return (
      <div className={this.props.pill ? "BackButton--pill" : "BackButton"}>
        <Link to={this.props.path}>
          Back
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/lib/BackButton.js